import ViewUtil from '../ViewUtil';
// import showLoginDialog from './showLoginDialog';

/**
 * Method decorator. For authenticated users, this is a no-op.
 * For link users, this prompts the user to login before
 * executing the wrapped method.
 */
export default function loginRequired(target, name, descriptor) {
  const original = descriptor.value;
  descriptor.value = function(...args) {
    if (!ViewUtil.isDirectLinkToCollection()) {
      return original.apply(this, args);
    }

    return null;
    // return showLoginDialog()
    //   .then((success) => {
    //     if (success) {
    //       return original.apply(this, args);
    //     }
    //   })
    //   .catch(err => console.error(err));
  };

  return descriptor;
}
